module.exports = __webpack_public_path__ + "img/Menu_unidad.c08882b3.svg";